<template>
  <el-tabs tab-position="left" style="height: 100%;" class="demo-tabs">
    <el-tab-pane label="最热" style=" padding: 20px;">
      <el-row :gutter="20">
        <el-col :span="6" v-for="course in courseHotList" :key="course.courseId" @click="joinCourse(course.courseId)">
            <el-card style="max-width: 480px;" class="courseCard no-padding"> 
              <img :src="course.courseImg" style="width: 100%; height: 150px;"/>
                <template #footer>
                  <h6>{{ course.courseName }}</h6>
                  <span class="courseCardFont">主讲人:{{ course.teacher.nickName }}</span>
                  <hr style="margin: 0px">
                  <span class="overlay-text-public" v-if="course.isPublic == 0">公开课</span>  
                  <span class="overlay-text-private" v-if="course.isPublic == 1">私有课</span>  
                  <span class="courseCardFont" style="float:right;">{{ course.headCount }}人参加</span>
                </template> 
            </el-card>
        </el-col>
    </el-row>
    </el-tab-pane>
    <el-tab-pane label="最新" style=" padding: 20px;">
        <el-row :gutter="20">
            <el-col :span="6" v-for="course in courseNewList" :key="course.courseId" >
                <el-card style="max-width: 480px;" class="courseCard" @click="joinCourse(course.courseId)"> 
                    <img :src="course.courseImg" style="width: 100%; height: 150px;"/>
                    <template #footer>
                      <h6>{{ course.courseName }}</h6>
                      <span class="courseCardFont">主讲人:{{ course.teacher.nickName }}</span>
                      <hr style="margin: 0px">
                      <span class="overlay-text-public" v-if="course.isPublic == 0">公开课</span>  
                      <span class="overlay-text-private" v-if="course.isPublic == 1">私有课</span>  
                      <span class="courseCardFont" style="float:right;">{{ course.headCount }}人参加</span>
                    </template> 
                </el-card>
            </el-col>
        </el-row>
    </el-tab-pane>
  </el-tabs>

  <nav aria-label="..." style="margin-left: 45%;">
    <ul class="pagination" style="float: center">
      <li class="page-item" @click="click_page(-2)">
        <a class="page-link" href="#">前一页</a>
      </li>
      <li
        :class="'page-item ' + page.is_active"
        v-for="page in pages"
        :key="page.number"
        @click="click_page(page.number)"
      >
        <a class="page-link" href="#">{{ page.number }}</a>
      </li>
      <li class="page-item" @click="click_page(-1)">
        <a class="page-link" href="#">后一页</a>
      </li>
    </ul>
  </nav>
</template>

<script setup>
import { ref, onMounted,defineExpose } from "vue";
import $ from "jquery";
import { useRoute } from "vue-router";
import router from "@/router/index";

const courseHotList = ref([]);
const courseNewList = ref([]);
let current_page = 1;
let current_cateId = 0;
let current_courseName = '';
let total_course = 0;
let pages = ref([]);
const Route = useRoute(); //获取到值

onMounted(() => {
    // 获取路由参数并设置为 current_page
  current_page = parseInt(Route.params.page) || 1;
  current_cateId = parseInt(Route.params.cateId) || 0;
  current_courseName = Route.params.courseName || '';

  getAllCourse(0, current_page, current_cateId, current_courseName);
  getAllCourse(1, current_page, current_cateId, current_courseName);
});


const getAllCourse = (ishot, page, cateId, courseName) => {
current_page = page;
current_cateId = cateId;
current_courseName = courseName;
  $.ajax({
    url: "http://124.222.105.205:5000/get/api/course/getCourse",
    data: {
      page: page,
      isHot: ishot,
      cateId: cateId,
      courseName: courseName
    },
    type: "post",
    success(resp) {
      if (ishot == 1) {
        courseHotList.value = resp.data.list;
      } else if (ishot == 0) {
        courseNewList.value = resp.data.list;
      }
      total_course = resp.data.total;
      udpate_pages();
    },
    error() {},
  });
};

const click_page = (page) => {
    console.log("page:" + page);
  if (page === -2) page = current_page - 1;
  else if (page === -1) page = current_page + 1;
  let max_pages = parseInt(Math.ceil(total_course / 16));
  if (page >= 1 && page <= max_pages) {
    getAllCourse(0, page, current_cateId, current_courseName);
    getAllCourse(1, page, current_cateId, current_courseName);
  }
};

const udpate_pages = () => {
  let max_pages = parseInt(Math.ceil(total_course / 16));
  let new_pages = [];
  for (let i = current_page - 2; i <= current_page + 2; i++) {
    if (i >= 1 && i <= max_pages) {
      new_pages.push({
        number: i,
        is_active: i === current_page ? "active" : "",
      });
    }
  }
  pages.value = new_pages;
  router.push({ name: "course", params: { page: current_page, cateId: current_cateId , courseName: current_courseName} });
};

const joinCourse = (id) => {
  const a = document.createElement('a');
  a.href = `/CourseDetail/${id}`; // 假设课程详情页面的路由是/course/:courseId
  a.target = '_blank'; // 在新页面中打开
  a.click(); // 触发点击事件
}

defineExpose({ getAllCourse });
</script>

<style scoped>
.courseCard {
  border-radius: 20px;
  margin: 20px 0px;
  padding: 0px;
  transition: transform 0.3s; /* 添加过渡效果 */
}

.courseCard:hover{
     cursor: pointer;
     transform: translateY(-10px); /* 在hover时向上移动5像素 */
    transition: 350ms;
    box-shadow: 12px 5px 5px rgb(164, 164, 164);
}

.courseCardFont{
  font-size: xx-small;
  color: gray;
}

.overlay-text-public {
    width: auto; /* Adjust width based on content */
    padding: 5px; /* Add padding for better appearance */
    background-color: rgba(255, 218, 163, 0.97); /* Set background color and opacity */
    font-size: 8px; /* Decrease font size */
    color: rgb(0, 0, 0); /* Set text color */
    border-radius: 5%; /* Add border radius for rounded corners */
}

.overlay-text-private {
    width: auto; /* Adjust width based on content */
    padding: 5px; /* Add padding for better appearance */
    background-color: rgba(230, 179, 245, 0.97); /* Set background color and opacity */
    font-size: 8px; /* Decrease font size */
    color: rgb(255, 255, 255); /* Set text color */
    border-radius: 5%; /* Add border radius for rounded corners */
}

/deep/ .el-card__body{
    padding: 0px;
  }

</style>